import React, { useEffect, useState } from 'react'
import AOS from 'aos'
import { motion } from 'framer-motion'
import Testimonials from '../Testimonials'
import Footer from '../../Footer/Footer'
import nacerAnimated from '../../../assets/images/Screen Recording (29-05-2022 5-42-10 PM).gif'
import logoNacer from '../../../assets/images/logo-nacer.webp'
import { FaSuitcase } from 'react-icons/fa'
import { BiEnvelopeOpen, BiHome } from 'react-icons/bi'
import DownloadCvModal from '../../DownloadCvModal'

const About = () => {
  useEffect(() => {
    AOS.init()
  }, [])

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    import('./index.css')
    import('aos/dist/aos.css')
    import('../index.scss')
      .then(() => setLoading(false)) // CSS is imported, stop loading
      .catch(() => setLoading(false)) // In case of error, stop loading as well
  }, [])

  return (
    <>
      {loading ? (
        <></>
      ) : (
        <>
          <header class="header">
            <a href="https://nacermediouni.vercel.app">
              <img class="logo" src={logoNacer} alt="my logo" />
            </a>
          </header>
          <motion.section
            class="cont ab active"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div class="mai-title">
              <h2>
                About <span>me</span>
                <span class="bg-text">Self Intro</span>
              </h2>
            </div>
            <motion.div
              animate={{ x: [0, 8, 0] }}
              transition={{ ease: 'easeOut', duration: 2 }}
              class="ab-cont"
            >
              <div class="left-ab">
                <h3>
                  Empathy, visualization, curiosity, communication, long-term
                  vision, and attention to detail are my underlying strengths.
                </h3>
                <p></p>
                {/* <div class="btn-con">
              <a
                href={cvNacer}
                class="mai-btn"
                target="_blank"
                rel="noopener noreferrer"
                download="nacerMediouni_resume_2024.pdf"
              >
                <span class="btn-text">Download CV</span>
                <span class="btn-icon">
                  <i class="fas fa-download"></i>
                </span>
              </a>
            </div> */}
              </div>
              <div class="sn">
                <div class="cn"></div>
                {/* <span class="text">Scroll Down!</span> */}
              </div>
            </motion.div>

            <div
              data-aos="fade-zoom-in"
              data-aos-easing="ease-in-back"
              class="ab-stats"
            >
              <h2>
                <h4>I am...</h4>
                <br />
                A versatile Digital Product Engineer, merging UX/UI design flair
                with Front-end development. With a startup-focused and big firm
                background, I excel in crafting user-centric interfaces using
                Figma while navigating projects with finesse. My passion lies in
                exploring innovative tools, particularly within the JavaScript
                frameworks realm (React, Next JS, ..).
                <br />
                <br />
                <h4>What I am looking for...</h4>
                <br />
                In my next role, I seek a challenging position that allows me to
                leverage my dual expertise in Front-end development and UX/UI
                design, with the added dimension of project management. I am
                drawn to dynamic companies, where innovation is valued. I aim to
                contribute to creative projects and growth-focused cultures.
                <br />
                <br />
                <h4>My strongest skills and how I learned them...</h4>
                <br />
                Specialized in React.js, JS, HTML/CSS (+3 years) for scalable,
                clean, visually appealing web applications alongside senior
                colleagues in my current and previous roles as Front-end
                developer and Instructor. Engaged in project management (2
                years) and UX/UI design (3 years), I create visually compelling,
                user-friendly designs for freelance projects.
                <br />
                <br />
                <h4>One fact (outside of work) about me...</h4>
                <br />
                Beyond work, I'm a dynamic blend of interests. Whether it's the
                adrenaline of sports, the fulfillment of community volunteering,
                the wanderlust for travel, or the creative expression through
                art, I thrive on a diverse range of passions that add depth and
                vibrancy to my life.
                <br />
                <br />
                <b>TECH STACK</b>
                <br />
                <br />
                <b>Front-end: </b>
                HTML, CSS, Styled-components, Sass, Scss, Tailwind CSS,
                Bootstrap, JavaScript, Typescript, React.js, Next.js, Gatsby.js,
                REST API, GraphQL, Strapi, Cypress, Jest, Storybook, Jotai,
                Redux, Jira, Git.
                <br />
                <br />
                <b>UX/UI: </b> Figma - AdobeXD - User Research - Usability
                Testing - User Analysis - Wireframing - Prototyping -
                Interaction Design - Information Architecture (IA) - Visual
                Design - Branding - Accessibility (W3C Standards) - Empathy &
                User-Centered Design - Communication & Collaboration -
                Adaptability & Problem-Solving
              </h2>
              <br />

              {/* <h4 class="stat-title">My Skills</h4>
              <div class="progress-bars">
                <div class="progress-bar">
                  <p class="prog-title">Design Thinking</p>
                  <div class="progress-con">
                    <p class="prog-text">80%</p>
                    <div class="progress">
                      <span class="eigthy-percent"></span>
                    </div>
                  </div>
                </div>{' '}
                <div class="progress-bar">
                  <p class="prog-title">Decision Mapping</p>
                  <div class="progress-con">
                    <p class="prog-text">80%</p>
                    <div class="progress">
                      <span class="eigthy-percent"></span>
                    </div>
                  </div>
                </div>{' '}
                <div class="progress-bar">
                  <p class="prog-title">Prototyping</p>
                  <div class="progress-con">
                    <p class="prog-text">80%</p>
                    <div class="progress">
                      <span class="eigthy-percent"></span>
                    </div>
                  </div>
                </div>
                <div class="progress-bar">
                  <p class="prog-title">Empathy</p>
                  <div class="progress-con">
                    <p class="prog-text">80%</p>
                    <div class="progress">
                      <span class="eigthy-percent"></span>
                    </div>
                  </div>
                </div>
                <div class="progress-bar">
                  <p class="prog-title">Adobe Illustrator</p>
                  <div class="progress-con">
                    <p class="prog-text">65%</p>
                    <div class="progress">
                      <span class="sixty-five-percent"></span>
                    </div>
                  </div>
                </div>
                <div class="progress-bar">
                  <p class="prog-title">Figma</p>
                  <div class="progress-con">
                    <p class="prog-text">80%</p>
                    <div class="progress">
                      <span class="eigthy-percent"></span>
                    </div>
                  </div>
                </div>
                <div class="progress-bar">
                  <p class="prog-title">Sketch</p>
                  <div class="progress-con">
                    <p class="prog-text">60%</p>
                    <div class="progress">
                      <span class="mongoDB"></span>
                    </div>
                  </div>
                </div>
                <div class="progress-bar">
                  <p class="prog-title">Adobe XD</p>
                  <div class="progress-con">
                    <p class="prog-text">60%</p>
                    <div class="progress">
                      <span class="sixty-percent"></span>
                    </div>
                  </div>
                </div>{' '}
                <div class="progress-bar">
                  <p class="prog-title">html5</p>
                  <div class="progress-con">
                    <p class="prog-text">80%</p>
                    <div class="progress">
                      <span class="eigthy-percent"></span>
                    </div>
                  </div>
                </div>
                <div class="progress-bar">
                  <p class="prog-title">css3</p>
                  <div class="progress-con">
                    <p class="prog-text">85%</p>
                    <div class="progress">
                      <span class="css"></span>
                    </div>
                  </div>
                </div>
                <div class="progress-bar">
                  <p class="prog-title">javascript (ES6 +)</p>
                  <div class="progress-con">
                    <p class="prog-text">60%</p>
                    <div class="progress">
                      <span class="js"></span>
                    </div>
                  </div>
                </div>
                <div class="progress-bar">
                  <p class="prog-title">ReactJS</p>
                  <div class="progress-con">
                    <p class="prog-text">70%</p>
                    <div class="progress">
                      <span class="react"></span>
                    </div>
                  </div>
                </div>
                <div class="progress-bar">
                  <p class="prog-title">NodeJS</p>
                  <div class="progress-con">
                    <p class="prog-text">45%</p>
                    <div class="progress">
                      <span class="fourty-five-percent"></span>
                    </div>
                  </div>
                </div>
                <div class="progress-bar">
                  <p class="prog-title">MongoDB (CRUD)</p>
                  <div class="progress-con">
                    <p class="prog-text">50%</p>
                    <div class="progress">
                      <span class="fifty-percent"></span>
                    </div>
                  </div>
                </div>{' '}
                <div class="progress-bar">
                  <p class="prog-title">Express (Routing)</p>
                  <div class="progress-con">
                    <p class="prog-text">50%</p>
                    <div class="progress">
                      <span class="fifty-percent"></span>
                    </div>
                  </div>
                </div>
                <div class="progress-bar">
                  <p class="prog-title">Git</p>
                  <div class="progress-con">
                    <p class="prog-text">60%</p>
                    <div class="progress">
                      <span class="sixty-percent"></span>
                    </div>
                  </div>
                </div>{' '}
                <div class="progress-bar">
                  <p class="prog-title">Adobe Photoshop</p>
                  <div class="progress-con">
                    <p class="prog-text">60%</p>
                    <div class="progress">
                      <span class="sixty-percent"></span>
                    </div>
                  </div>
                </div>
                <div class="progress-bar">
                  <p class="prog-title">SOLIDWORkS</p>
                  <div class="progress-con">
                    <p class="prog-text">80%</p>
                    <div class="progress">
                      <span class="eigthy-percent"></span>
                    </div>
                  </div>
                </div>{' '}
                 <div class="progress-bar">
              <p class="prog-title">Catia</p>
              <div class="progress-con">
                <p class="prog-text">60%</p>
                <div class="progress">
                  <span class="sixty-percent"></span>
                </div>
              </div>
            </div> 
              </div> */}
            </div>
            <h4 class="stat-title">My Timeline</h4>
            <h4 class="stat-title">Where I’ve Worked</h4>
            <div class="timeline">
              <div class="timeline-item">
                <div class="tl-icon">
                  <FaSuitcase />
                </div>
                <p class="tl-duration">June 2021 - Today</p>
                <h5>
                  UX/UI Designer & FrontEnd Developer
                  <span> - Freelancer </span>
                </h5>
                <p>
                  As a freelance UX/UI designer and Frontend developer, I
                  specialize in building dynamic, responsive websites and
                  applications using a range of cutting-edge technologies. My
                  role involves collaborating with clients to ensure the website
                  meets business goals, user needs, and industry standards. I
                  also focus on optimizing performance and ensuring cross-device
                  compatibility.
                </p>
              </div>
              <div class="timeline-item">
                <div class="tl-icon">
                  <FaSuitcase />
                </div>
                <p class="tl-duration">January 2025 - Today</p>
                <h5>
                  Product(UX/UI) Design Consultant
                  <span> - Ooredoo Tunisia </span>
                </h5>
                <p>
                  As a Product design consultant, I am Leading the end-to-end
                  redesign of Tunisia's 1# telecom platform (mobile & web apps),
                  serving 2 M+ monthly active users and 9.3 M+ App total
                  download, by leveraging Figma to enhance UX/UI, streamline
                  navigation, and deliver modern interfaces.
                </p>
              </div>
              <div class="timeline-item">
                <div class="tl-icon">
                  <FaSuitcase />
                </div>
                <p class="tl-duration">October 2021 - June 2024</p>
                <h5>
                  UX Engineer (FrontEnd Developer & UX/UI Designer)
                  <span> - Tayara Group</span>
                </h5>
                <p>
                  As a Frontend Developer and UX/UI Designer at{' '}
                  <a href="https://www.tayara.tn/">
                    {' '}
                    <b>tayara.tn</b>
                  </a>
                  , an online marketplace serving over 1,000,000+ users in
                  Tunisia, France, and Germany, my mission is to blend
                  creativity and technical expertise to enhance the overall user
                  experience and visual appeal of the platform. I am responsible
                  for designing intuitive user interfaces, ensuring a smooth and
                  engaging journey for users. Simultaneously, my role extends to
                  implementing these designs on the Frontend, bridging the gap
                  between design concepts, and responsive features aligned with
                  the brand identity and business objectives of the platform.
                  Through a combination of design thinking, user research, and
                  coding skills, I contribute to the evolution of Tayara,
                  elevating user satisfaction and interaction across various
                  devices.
                </p>
              </div>
              <div class="timeline-item">
                <div class="tl-icon">
                  <FaSuitcase />
                </div>
                <p class="tl-duration">Jul 2022 - Jul 2023</p>
                <h5>
                  Front-End Web Development Instructor (React.js)
                  <span> - GOMYCODE Tunisia</span>
                </h5>
                <p>
                  I work as a part-time instructor for the React JS introduction
                  course. Supporting students in understanding and applying
                  fundamental concepts of ReactJS, assisting them in getting
                  acquainted with web development, and guiding them through
                  practical projects and interactive sessions to enhance their
                  learning experience.
                </p>
              </div>

              <div class="timeline-item">
                <div class="tl-icon">
                  <FaSuitcase />
                </div>
                <p class="tl-duration">July 2020 - May 2021</p>
                <h5>
                  Projects Coordinator
                  <span> - MBA Consulting</span>
                </h5>
                <p>
                  I was in charge of the internal and external coordination with
                  the experts assigned to the projects, as well as the entire
                  administrative and technical operations of the different
                  projects.
                </p>
              </div>
              <div class="timeline-item">
                <div class="tl-icon">
                  <FaSuitcase />
                </div>
                <p class="tl-duration">January 2020 - June 2020</p>
                <h5>
                  IT Project Manager<span> - EL Space</span>
                </h5>
                <p>
                  I managed and coordinated the development of the platform and
                  project activities, as well as being responsible for the
                  internal coordination of staff working on the project, and
                  liaison with local and international partners.
                </p>
              </div>

              {/* <div class="timeline-item">
            <div class="tl-icon">
              <FaSuitcase/>
            </div>
            <p class="tl-duration">February 2019 - June 2019</p>
            <h5>
              Project Management Intern<span> - UVT/EPPM</span>
            </h5>
            <p>
              Implemented a strategic Corporate Social Responsibility approach
              at the company's headquarters according to the ISO 26000 standard.
            </p>
          </div> */}
              <div class="timeline-item">
                <div class="tl-icon">
                  <FaSuitcase />
                </div>
                <p class="tl-duration">July 2019 - July 2019</p>
                <h5>
                  Project Consultant<span> - EPPM</span>
                </h5>
                <p>Developed a dashboard for monitoring HSE projects </p>
              </div>
              <div class="timeline-item">
                <div class="tl-icon">
                  <FaSuitcase />
                </div>
                <p class="tl-duration">2017 - 2019</p>
                <h5>
                  Team Lead <span> - AIESEC in Tunisia</span>
                </h5>
                <p>
                  Led the International incoming global volunteer departments'
                  team.
                </p>
              </div>
              <div class="timeline-item">
                <div class="tl-icon">
                  <FaSuitcase />
                </div>
                <p class="tl-duration">May 2018 - August 2018</p>
                <h5>
                  Project Founder/Manager<span> - AIESEC In Tunisia</span>
                </h5>
                <p>
                  Managed and supervised three teams of +30 people including 9
                  International exchange participant volunteers to ensure
                  successful completion of the project.
                </p>
              </div>
              {/* <div class="timeline-item">
            <div class="tl-icon">
              <FaSuitcase/>
            </div>
            <p class="tl-duration">2017 - present</p>
            <h5>
              Quality Control Inspector<span> - FINNORD Tunisia</span>
            </h5>
            <p>
              Managed with the quality manager a team of 25 employees to ensure
              the effectiveness of the control system of quality and meet KPI
              targets: we managed to reduce the scrap rate from 2.5% to 1.02%.
            </p>
          </div> */}
              {/* <div class="timeline-item">
            <div class="tl-icon">
              <FaSuitcase/>
            </div>
            <p class="tl-duration">2017 - present</p>
            <h5>
              Mechanical Designer<span> - IDEMPRO</span>
            </h5>
            <p>
              Design a 3-axis sliding table prototype with a functional
              specification for a laser welding machine. (SOLIDWORKS)
            </p>
          </div> */}
            </div>
            <h4 class="stat-title">Testimonials</h4>
            <h4 class="stat-title">What people say about me</h4>

            <Testimonials />
            <img
              className="relative w-[60%] my-28 mx-auto"
              src={nacerAnimated}
              alt="nacer's album"
            />

            <div className="  w-full flex flex-col justify-center items-center pt-20 pb-8 px-[10%] md:px-[20%] font-sans ">
              <Footer />
            </div>
          </motion.section>
          <div class="controls">
            <div class="control" data-id="home">
              <a href="/">
                <BiHome size={20} />
              </a>
            </div>
            <div class="control" data-id="contact">
              <a href="https://www.linkedin.com/in/nacer-mediouni/">
                <BiEnvelopeOpen size={20} />
              </a>
            </div>
            <div class="control" data-id="resume">
              {/* <a
                href="../../../assets/Nacer_Mediouni_UXEngineer_Resume.pdf"
                download
              >
                <FaRegFilePdf size={20} />
              </a> */}
              <DownloadCvModal />
            </div>
            <a
              href="/works"
              className="font-bold text-white underline underline-offset-8  active:text-gray-500 mt-16 rotate-90 w-fit h-fit "
            >
              View Projects
            </a>
          </div>
        </>
      )}
    </>
  )
}

export default About
